import { Outlet } from 'react-router-dom';
import ConsentForm from '../components/ConsentForm';
import { PatientFormProvider, usePatientForm } from '../context/PatientFormContext';

function ConsentDeclinedView({ onLogout }) {
  const { setConsent } = usePatientForm();

  return (
    <div
      className="page-content"
      style={{ textAlign: 'center', padding: '100px 24px' }}
    >
      <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🚫</div>

      <h2
        style={{
          fontFamily: 'Outfit',
          fontSize: '1.6rem',
          marginBottom: '12px',
          color: 'var(--text-primary)',
        }}
      >
        Consent Declined
      </h2>

      <p
        style={{
          color: 'var(--text-secondary)',
          marginBottom: '32px',
          maxWidth: '400px',
          margin: '0 auto 32px',
        }}
      >
        You have chosen not to share your information. No data has been recorded.
      </p>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
        }}
      >
        <button
          className="btn btn-primary"
          onClick={() => setConsent(null)}
        >
          Reconsider
        </button>

        <button
          className="btn btn-outline"
          onClick={onLogout}
        >
          Exit Portal
        </button>
      </div>
    </div>
  );
}

function RegisterLayoutContent({ onLogout }) {
  const { consent, setConsent } = usePatientForm();

  if (consent === null) {
    return (
      <ConsentForm
        onAccept={() => setConsent(true)}
        onDecline={() => setConsent(false)}
        onBack={onLogout}
      />
    );
  }

  if (consent === false) {
    return <ConsentDeclinedView onLogout={onLogout} />;
  }

  return (
    <div className="page-content">
      <Outlet />
    </div>
  );
}

export default function RegisterLayout({ patient, onSubmit, onLogout }) {
  return (
    <PatientFormProvider patient={patient} onSubmit={onSubmit}>
      <RegisterLayoutContent onLogout={onLogout} />
    </PatientFormProvider>
  );
}
